export default {
  navigator: {
    btn: {
      show_alarms: '查看所有报警'
    },
    columns: {
      title: '报警内容',
      time: '时间'
    }
  }
}
